export const sendAnalyticsData = (actionType) => {
  if (typeof actionType !== 'string') {
    return;
  }
  window.uetq_sp = window.uetq_sp || [];
  window.uetq_sp.push('event', 'Click', {
    // 'contactUs' => 'contact US'
    event_label: actionType,
  });
};
